import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { resultsTimeline } from '@/mocks/results';
import { communityUrl } from '@/mocks/strategix';

export default function ResultsTimeline() {
  return (
    <section className="relative w-full px-5 md:px-10 pb-20 md:pb-28">
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          label="За месяц"
          title="Как выглядит рост за месяц"
          description="Типовая схема запуска продвижения: от подготовки креативов до стабильного набора аудитории в течение одного месяца."
        />

        <div className="mt-12 relative">
          <div className="absolute left-5 top-2 bottom-2 w-px bg-background-200" aria-hidden="true"></div>
          <div className="space-y-8">
            {resultsTimeline.map((item, index) => (
              <Reveal key={item.duration} delay={index * 70}>
                <div className="relative flex gap-5">
                  <span className="relative z-10 flex-none w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-heading font-bold text-sm">
                    {index + 1}
                  </span>
                  <div className="flex-1 p-5 rounded-lg bg-background-100/70 border border-background-200/70">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                      <h3 className="font-heading text-base md:text-lg text-foreground-950">{item.title}</h3>
                      <span className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold whitespace-nowrap">
                        {item.duration}
                      </span>
                    </div>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.text}</p>
                    <div className="mt-3 text-sm font-semibold text-primary-500">{item.metric}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={150}>
          <div className="mt-12 flex flex-col lg:flex-row items-start lg:items-center gap-5 p-6 md:p-7 rounded-lg border border-accent-500/40 bg-accent-500/10">
            <span className="w-12 h-12 flex-none flex items-center justify-center rounded-md bg-accent-500/20 text-accent-300">
              <i className="ri-trophy-line text-2xl"></i>
            </span>
            <div className="flex-1">
              <h3 className="font-heading text-base md:text-lg text-foreground-950">Хотите такие же цифры?</h3>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                Расскажите о своём сообществе — спрогнозируем рост под вашу нишу и бюджет. Наполнение тарифов
                уточняйте в сообществе.
              </p>
            </div>
            <a
              href={communityUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-full lg:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-vk-line text-base"></i>
              Перейти в сообщество
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}